import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userDataKader = localStorage.getItem("userDataKader") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader")))) : "";
var serviceName = "controller";
var controllerService = {
    imageUrlBuyuk: WsProvider.resim+"/"+userDataKader["firmaKodu"]+"/buyuk/",
    imageUrlOrta: WsProvider.resim+"/"+userDataKader["firmaKodu"]+"/orta/",
    imageUrlKucuk: WsProvider.resim+"/"+userDataKader["firmaKodu"]+"/kucuk/",
    resimYukle(modul,name, base) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                modul: modul,
                name: name,
                base: base,
                methodName: "resimyukle",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sunucuResim(modul) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                modul: modul,
                methodName: "sunucuResim",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

    belgeYukle(modul,name, base) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                modul: modul,
                name: name,
                base: base,
                methodName: "belgeyukle",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    sunucuBelge(modul) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                modul: modul,
                methodName: "sunucuBelge",
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    }
};
export default controllerService



